import { useSiteStore } from '../../utils/store/useSiteStore';
import useIsMobile from '../../utils/hooks/useIsMobile';
import CTAButton from '../general/CTAButton';
import s from '../../styles/components/home/Hero.module.css';

export default function Hero({ data }) {
  const { videoSrc, posters, logoSrc, headline, subhead, cta } = data;
  const hasVideo = useSiteStore((state) => state.hasVideo);
  const isMobile = useIsMobile();

  return (
    <section className={s.container}>
      {hasVideo ? (
        <video
          className={s.video}
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <div className={s.galleryWrap}>
          <div className={s.galleryTrack}>
            {[...posters, ...posters].map((poster, i) => (
              <div key={i} className={s.galleryCell}>
                <img src={poster.image} alt={poster.imageAlt} className={s.galleryImage} />
              </div>
            ))}
          </div>
        </div>
      )}
      <div className={s.overlay} />
      <div className={s.content}>
        <img src={logoSrc} alt="Logo" className={isMobile ? s.logoMobile : s.logo} />
        <h1 className={s.headline}>{headline}</h1>
        <CTAButton label={cta.label} url={cta.url} />
      </div>
    </section>
  );
}